import { render, staticRenderFns } from "./AnnotationSelection.vue?vue&type=template&id=4ff03de9&scoped=true"
import script from "./AnnotationSelection.vue?vue&type=script&lang=js"
export * from "./AnnotationSelection.vue?vue&type=script&lang=js"
import style0 from "./AnnotationSelection.vue?vue&type=style&index=0&id=4ff03de9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff03de9",
  null
  
)

export default component.exports